import {
    BannerSlots,
    Buttons,
    CarouselProducts,
    FeaturedProducts,
    FiveSlotBanner,
    Paragraphs,
    SingleBanner,
    TextHeadline,
} from "@/Slice"
import { CategoryDocument } from "@/lib/prismicio/types.generated"
import { PropsWithChildren } from "react"

export const SliceRender = ({ slices }: PropsWithChildren<{ slices: CategoryDocument["data"]["body"] }>) => (
    <div>
        {[...slices]
            .filter((slice) => !slice.primary.is_hide_module)
            .map((slice, index) => (
                <Slice key={index} slice={slice} lcp={index < 2} />
            ))}
    </div>
)
const BASE_MARGIN = "mt-0.5 first:mt-0"

export const Slice = ({
    slice,
    lcp,
}: PropsWithChildren<{ slice: CategoryDocument["data"]["body"][number]; lcp: boolean }>) => {
    switch (slice.slice_type) {
        case "single_banner": {
            return <SingleBanner className={BASE_MARGIN} slice={slice} lcp={lcp} />
        }
        case "text_headline": {
            return <TextHeadline slice={slice} />
        }
        case "two_slot_banner":
        case "three_slot_banner":
        case "four_slot_banner":
        case "six_slot_banner": {
            return <BannerSlots className={BASE_MARGIN} slice={slice} lcp={lcp} />
        }
        case "five_slot_banner": {
            return <FiveSlotBanner className={BASE_MARGIN} slice={slice} lcp={lcp} />
        }
        case "paragraphs": {
            return <Paragraphs className="mt-10 mb-5 first:mt-8" slice={slice} />
        }
        case "featured_products": {
            return <FeaturedProducts className={BASE_MARGIN} slice={slice} lcp={lcp} />
        }
        case "carousel_products": {
            return <CarouselProducts className={BASE_MARGIN} slice={slice} lcp={lcp} />
        }
        case "buttons": {
            return <Buttons className={BASE_MARGIN} slice={slice} />
        }
        default: {
            return <></>
        }
    }
}
